import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteNotificationsListError, deleteNotificationsListSuccess,

    getNotificationsListError,
    getNotificationsListSuccess
} from './actions';
import {
    NOTIFICATION_DELETE_ITEMS, NOTIFICATION_GET_LIST
} from './actions_def';


const apiUrl = servicePath;

const getNotificationsListRequest = async () => {
    // console.log("getNotificationsList")

    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/notifications/',
            { crossdomain: true })
            .then(response => success(response.data ? response.data : []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getNotificationsList() {
    try {
        const response = yield call(getNotificationsListRequest);
        yield put(getNotificationsListSuccess(response));
    } catch (error) {
        yield put(getNotificationsListError(error));
    }
}

const deleteNotificationsListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (items.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        items.map(item => {
            // console.log(item)
            instance.delete('/notifications/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.status === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.status === "success" || response.data.status === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.status)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteNotificationsList({ payload }) {
    // // // console.log(payload);;

    try {
        const response = yield call(deleteNotificationsListRequest, payload);
        yield put(deleteNotificationsListSuccess(response));
    } catch (error) {
        yield put(deleteNotificationsListError(error));
    }
}



export function* watchGetNotificationsList() {
    // console.log('watchGetNotificationsList');
    yield takeEvery(NOTIFICATION_GET_LIST, getNotificationsList);
}

export function* watchDeleteNotification() {
    yield takeEvery(NOTIFICATION_DELETE_ITEMS, deleteNotificationsList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetNotificationsList),
        fork(watchDeleteNotification),
    ]);
}
